import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseService} from './base.service';
import {Observable} from 'rxjs';
import {AlertService} from './alert.service';
import {GlobalService} from './global.service';
import {AppUrl} from '../constants/app-url';

@Injectable({
    providedIn: 'root'
})
export class PartnerPopularCourseService extends BaseService {
    constructor(public http: HttpClient,
                public alertService: AlertService,
                public globalService: GlobalService) {
        super(http, alertService, globalService);
    }

    get(partnerId): Observable<any> {
        return this.getRequest(AppUrl.PARTNER_POPULAR_COURSE_LINK(partnerId));
    }

    link(partnerId, popularCourseIds: number[]): Observable<any> {
        return this.postRequest(AppUrl.PARTNER_POPULAR_COURSE_LINK(partnerId), {popular_course_ids: popularCourseIds});
    }

    unlink(partnerId, popularCourseId): Observable<any> {
        return this.deleteRequest(AppUrl.PARTNER_POPULAR_COURSE_LINK(partnerId, popularCourseId));
    }
}
